import { Tabs } from 'src/components/molecules/Tabs';
import { TabsWithButtonGroup } from 'src/components/molecules/TabsWithButtonGroup';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const CaseContainer = styled.div`
  background: ${(props) => props.theme.atlas.semantic.color.surface.variant};
  height: 100%;
  min-width: 1020px;
`;

export const CasePageUpperPanelsContainer = styled.div`
  display: grid;
  grid-template-columns: 33% 1fr;
  gap: 16px;
`;

export const ReportContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 2;
  width: 100%;
  & > div {
    padding: 25px 20px 20px 20px;
  }
  & > div:first-child {
    border-right: 1px solid
      ${(props) => props.theme.atlas.semantic.color.surface.variant};
  }
`;

export const CaseReportEventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
`;

export const StyledTabsWithButtonGroup = styled(TabsWithButtonGroup)`
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
`;

export const StyledTabs = styled(Tabs)`
  background: ${(props) => props.theme.atlas.semantic.color.surface.variant};
`;

export const DeletePIIContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DeletePIIContentSegment = styled.div`
  margin-bottom: 20px;
`;

export const RemovePIIContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

export const RemovePIIHeaderStyled = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
`;

export const AccordionContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

export const RemovePIIEventDetailDescription = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin-bottom: 10px;
  font-weight: 500;
`;

export const ExternalNamedOffendersList = styled.div`
  padding: 5px 20px;
`;
